<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="银行名称">
                  <el-input  v-model="queryForm.bankName"></el-input>
              </el-form-item>
<!--              <el-form-item label="银行LOGO">-->
<!--                  <el-input  v-model="queryForm.bankLogo"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="银行编码">-->
<!--                  <el-input  v-model="queryForm.bankCode"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item-->
<!--                  label="是否默认"-->
<!--              >-->
<!--                  <el-select-->
<!--                      style="width:175.6px"-->
<!--                      v-model="queryForm.isDefault"-->
<!--                      size="small"-->
<!--                      placeholder="请选择"-->
<!--                      :disabled="mppBankState == 'check'"-->
<!--                  >-->
<!--                      <el-option-->
<!--                          label="否"-->
<!--                          :value="0"-->
<!--                      > </el-option>-->
<!--                      <el-option-->
<!--                          label="是"-->
<!--                          :value="1"-->
<!--                      > </el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppBankList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppBank"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppBank(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppBank(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppBankList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppBankList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      height='100%'
      :data="mppBankList"
      row-key="id"
      border
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bankName"
        label="银行名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bankLogo"
        label="银行LOGO"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bankCode"
        label="银行编码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isDefault"
        label="是否默认"
        width="180"
      >
          <template scope='scope'>
              <div v-if='scope.row.isDefault'>是</div>
              <div v-if='!scope.row.isDefault'>否</div>
          </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppBank(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppBank(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppBank(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppBankStates[mppBankState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="mppBank"
          ref="mppBankForm"
          :rules="rules"
          label-width="88px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="银行名称"
            prop="bankName"
          >
            <el-input
              size="small"
              v-model="mppBank.bankName"
              :disabled="mppBankState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="银行LOGO"
            prop="bankLogo"
          >
            <el-input
              size="small"
              v-model="mppBank.bankLogo"
              :disabled="mppBankState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="银行编码"
            prop="bankCode"
          >
            <el-input
              size="small"
              v-model="mppBank.bankCode"
              :disabled="mppBankState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
                label="是否默认"
                prop="isDefault"
            >
                <el-select
                    style="width:175.6px"
                    v-model="mppBank.isDefault"
                    size="small"
                    placeholder="请选择"
                    :disabled="mppBankState == 'check'"
                >
                    <el-option
                        label="否"
                        :value="false"
                    > </el-option>
                    <el-option
                        label="是"
                        :value="true"
                    > </el-option>
                </el-select>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppBankState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppBankList();
                    this.getMppBankList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppBankList();
                    this.getMppBankList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     bankName: '', //银行名称
                     bankLogo: '', //银行LOGO
                     bankCode: '', //银行编码
                     isDefault: '', //是否默认
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppBankState: 'add',
                mppBankStates: {
                    add: '新建银行',
                    check: '查看银行',
                    edit: '修改银行'
                },

                multipleSelection: [],
                mppBankList: [],
                mppBank: {
                    bankName: '', //银行名称
                    bankLogo: '', //银行LOGO
                    bankCode: '', //银行编码
                    isDefault: '', //是否默认
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                    bankLogo: [{ required: true, message: '银行LOGO不能为空', trigger: 'blur' }],
                    bankCode: [{ required: true, message: '银行编码不能为空', trigger: 'blur' }],
                    isDefault: [{ required: true, message: '是否默认不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppBankList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppBankList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppBankList = [];
            },
            resetDialog() {
                this.mppBankState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      bankName: '', //银行名称
                      bankLogo: '', //银行LOGO
                      bankCode: '', //银行编码
                      isDefault: '', //是否默认
                };
                this.getMppBankList();
            },
            closeDialog() {
                this.showDialog=false;
                this.mppBank = {
                      bankName: '', //银行名称
                      bankLogo: '', //银行LOGO
                      bankCode: '', //银行编码
                      isDefault: '', //是否默认
                };
            },
            submitForm() {
                if (this.mppBankState == 'add') {
                    this.$refs.mppBankForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/bank/add`,{ ...this.mppBank }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppBankList();
                                    this.resetDialog();
                                    this.getMppBankList();
                                }
                            });
                        }
                    });
                } else if (this.mppBankState == 'edit') {
                    this.$refs.mppBankForm.validate((valid) => {
                        if (valid) {
                            post(`/mpp/bank/edit`,{ ...this.mppBank }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppBankList();
                                    this.resetDialog();
                                    this.getMppBankList();

                                }
                            });
                        }
                    });
                }
            },
            addMppBank() {
                this.showDialog = true;
                this.mppBankState = 'add';
                this.mppBank = {
                    bankName: '', //银行名称
                    bankLogo: '', //银行LOGO
                    bankCode: '', //银行编码
                    isDefault: true, //是否默认
                };
            },
            checkMppBank(mppBankId) {
                console.log(mppBankId);
                this.currentMppBankId = mppBankId;

                this.getMppBankById();
                this.showDialog = true;
                this.mppBankState = 'check';
            },
            editMppBank(mppBankId) {
                console.log('mppBank', mppBankId);
                if (mppBankId) {
                    this.currentMppBankId = mppBankId;
                    this.getMppBankById();
                } else {
                    this.mppBank = { ...this.mppBank, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppBankState = 'edit';
            },
            deleteMppBank(mppBankId) {
                let ids = '';
                if (mppBankId) {
                    ids = mppBankId;
                } else {
                    ids = this.multipleSelection.map((mppBank) => mppBank.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/bank/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppBankList();
                                this.getMppBankList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppBankList() {
                this.resetMppBankList();
                this.getMppBankList();
            },
            getMppBankList(query = {}) {
                this.loading = true;
                get(`/mpp/bank/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppBankList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMppBankById() {
                get(`/mpp/bank/get`,{ id: this.currentMppBankId }).then((res) =>{
                    if(res.success){
                      this.mppBank = { ...this.mppBank, ...res.mppBank };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppBankList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/bank/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/bank/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/bank/importData`,formData);
              this.refreshMppBankList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppBankList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppBankList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
